import {AudioHandler} from "./AudioHandler";
import {breadcrumb} from "../../../utils/sentry";

export class WebmAudioHandler extends AudioHandler {
    protected stream: MediaStream | null = null;

    protected constraints: MediaStreamConstraints = {
        audio: true,
    };

    private recorder: MediaRecorder | null = null;

    async startRecording(stream: MediaStream) {
        console.info("[WebmAudioHandler] Setting audio input...");

        try {
            this.stream = stream;

            const [track] = this.stream.getAudioTracks();
            const settings = track.getSettings();
            console.log("[AudioHandler] Track settings:", settings);
            breadcrumb('audio', '[AudioHandler] Track settings:', settings)

            this.recorder = new MediaRecorder(this.stream);

            this.recorder.ondataavailable = async (event) => {
                try {
                    const buffer = await event.data.arrayBuffer();
                    this.ws.send(buffer);
                } catch (err) {
                    console.error("[WebmAudioHandler] MediaRecorder ondataavailable error:", err);
                }
            };

            this.recorder.start(250);
        } catch (error) {
            console.error("[WebmAudioHandler] Failed to set audio input:", error);
            throw error;
        }
    }

    async stop() {
        console.info("[WebmAudioHandler] Stopping audio input...");
        this.recorder?.stop();
        this.recorder = null
        this.stream = this.stopStream(this.stream)

        await super.stop()
    }
}
